export const LOGO_DISPLAY_SIZE = 64; // 256 / 4;
export const LOGO_IMAGE_SIZE = 256;
